import { createSlice } from "@reduxjs/toolkit";
import {
  getLanding,
  addNewLanding,
  updateLanding,
  deleteLanding,
} from "./thunk";

export const initialState = {
  landing: null,
  error: {},
  isLoading: false,
  isLandingSuccess: false,
  isLandingFailed: false,
};

const landingSlice = createSlice({
  name: "landing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getLanding/ ]=======================================
    builder.addCase(getLanding.pending, (state) => {
      state.isLoading = true;
      state.isLandingSuccess = false;
      state.error = null;
    });
    builder.addCase(getLanding.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isLandingSuccess = true;
      state.landing = action.payload;
    });
    builder.addCase(getLanding.rejected, (state, action) => {
      state.isLoading = false;
      state.isLandingSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewLanding.fulfilled, (state, action) => {
      state.landing = action.payload;
      state.isLandingAdd = true;
      state.isLandingAddFail = false;
    });

    builder.addCase(addNewLanding.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isLandingAdd = false;
      state.isLandingAddFail = true;
    });

    builder.addCase(updateLanding.fulfilled, (state, action) => {
      state.landing = state.landing.map((land) =>
        land._id.toString() === action.payload._id.toString()
          ? { ...land, ...action.payload }
          : land
      );
      state.isLandingUpdate = true;
      state.isLandingUpdateFail = false;
    });

    builder.addCase(updateLanding.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isLandingUpdate = false;
      state.isLandingUpdateFail = true;
    });

    builder.addCase(deleteLanding.fulfilled, (state, action) => {
      state.landing = (state.landing || []).filter(
        (land) => land._id.toString() !== action.payload.id.toString()
      );

      state.isLandingDelete = true;
      state.isLandingDeleteFail = false;
    });

    builder.addCase(deleteLanding.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isLandingDelete = false;
      state.isLandingDeleteFail = true;
    });
  },
});

export default landingSlice.reducer;
